import { inject, Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { finalize, shareReplay } from 'rxjs/operators';
import { HrtApiService } from '../hrt-api/hrt-api.service';
import { CreateTunnelRequest, WebVncInstance } from '@shared/models';

export interface CreateTunnelResult {
  websocketUrl: string;
}

@Injectable({
  providedIn: 'root',
})
export class RemoteAccessApiService {
  private readonly api = inject(HrtApiService);
  private readonly pendingInstanceRequests = new Map<string, Observable<CreateTunnelResult>>();

  createTunnel({ edgeGatewaySerialNumber, omniId, sourceIp }: CreateTunnelRequest): Observable<CreateTunnelResult> {
    const requestKey = `${edgeGatewaySerialNumber}:${omniId}:${sourceIp}`;
    const pending = this.pendingInstanceRequests.get(requestKey);

    if (pending) {
      return pending;
    }

    const request$ = this.api
      .post<CreateTunnelResult>(`remote-access/${encodeURIComponent(edgeGatewaySerialNumber)}/tunnel`, {
        omniId,
        sourceIp,
      })
      .pipe(
        shareReplay(1),
        finalize(() => this.pendingInstanceRequests.delete(requestKey))
      );

    this.pendingInstanceRequests.set(requestKey, request$);
    return request$;
  }

  listInstances(): Observable<WebVncInstance[]> {
    return this.api.get<WebVncInstance[]>('remote-access/instances');
  }

  closeInstance(instanceId: string): Observable<void> {
    return this.api.delete<void>(`remote-access/instances/${encodeURIComponent(instanceId)}`);
  }
}
